module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('SectionLabel', {
    attrs: {
      "label": _vm.trads.label
    }
  }), _vm._v(" "), (_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('section', [_c('label', [_vm._v(_vm._s(_vm.trads.estoreAvailability.label))]), _vm._v(" "), _c('RadioGroup', {
    attrs: {
      "id": "estore",
      "name": "estore",
      "options": _vm.estoreAvailability
    },
    model: {
      value: (_vm.value.eStoreType),
      callback: function($$v) {
        _vm.value.eStoreType = $$v
      },
      expression: "value.eStoreType"
    }
  })], 1), _vm._v(" "), (_vm.displayDefaultPriceContainer) ? _c('div', {
    staticClass: "default-price-container"
  }, [_c('label', [_vm._v(_vm._s(_vm.trads.defaultPrice))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.defaultPrice),
      callback: function($$v) {
        _vm.defaultPrice = $$v
      },
      expression: "defaultPrice"
    }
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "size": 's'
    },
    on: {
      "click": _vm.applyDefaultPrice
    }
  }, [_vm._v(_vm._s(_vm.trads.applyPrices))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayPriceContainer) ? _c('section', {
    attrs: {
      "id": "price-container"
    }
  }, [_vm._l((_vm.listDisplayed), function(zonePrice, index) {
    return _c('label', {
      key: zonePrice.zone.id,
      style: ({
        order: index * _vm.COLUMN_NUMBER_IN_TEMPLATE
      }),
      attrs: {
        "for": ("zone-" + (zonePrice.zone.id))
      }
    }, [_vm._v("\n            " + _vm._s(zonePrice.zone.name) + " "), (_vm.isDisabledZone(zonePrice.zone.id)) ? _c('span', [_c('i', [_vm._v("(DELETED)")])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.listDisplayed), function(zonePrice, index) {
    return _c('div', {
      key: zonePrice.zone.id,
      style: ({
        order: index * _vm.COLUMN_NUMBER_IN_TEMPLATE + 1
      })
    }, [_c('span', [_vm._v(_vm._s(zonePrice.currency.symbol))]), _vm._v(" "), (!_vm.isDisabledZone(zonePrice.zone.id)) ? _c('NumberInput', {
      attrs: {
        "value": zonePrice.value,
        "id": ("zone-" + (zonePrice.zone.id)),
        "style-object": {
          width: '50px'
        }
      },
      on: {
        "input": function (newValue) { return _vm.change(index, newValue); }
      }
    }) : _c('span', [_vm._v(" " + _vm._s(zonePrice.value) + " ")])], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ecd6f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/form-estore.vue
// module id = 3196
// module chunks = 0